import { Context } from '@nuxt/types';

export default function(context: Context) {
  const { redirect, query } = context;
  redirect('/nodes/founders-node/buy', query);
}
